import { withMemoDouble } from '@othrworld/memo-utils';
import { multUnit, unit } from '@othrworld/units';
import { radialToCarth } from './coords';
import { getNextDateAtTrueAnomaly, getTrueAnomaly } from './true-anomaly';
import { acosClamp } from './utils';
/** Returns the distance for a given true anomaly */
const getDistanceForTrueAnomaly = ({ a, e }, nu) => multUnit(a, (1 - Math.pow(e, 2)) / (1 + e * Math.cos(nu)));
/**
 * Returns the true anomaly for a given distance
 * @note Due to the symetry of the solutions, the negative value of the returned
 * function could also be usable.
 **/
const getTrueAnomalyForDistance = ({ a, e }, r) => unit(Math.acos(acosClamp(((a * (1 - Math.pow(e, 2))) / r - 1) / e)));
export const getRadialCoords = withMemoDouble((orbit, t) => {
    const trueAnomaly = getTrueAnomaly(orbit, t);
    const r = getDistanceForTrueAnomaly(orbit, trueAnomaly);
    return { r, angle: trueAnomaly };
});
export const getCarthesianCoords = withMemoDouble((orbit, t) => {
    const rad = getRadialCoords(orbit, t);
    rad.angle += orbit.phi;
    return radialToCarth(rad);
});
export const getNextDateForDistance = (orbit, r, t) => getNextDateAtTrueAnomaly(getTrueAnomalyForDistance(orbit, r), orbit, t);
//# sourceMappingURL=position.js.map